import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const SUPPLIER_CREDIT_API_URL = `${API_CONFIG.BASE_URL}/supplier-credit`;

const handleApiError = (error) => {
  throw error.response?.data?.message || error.message || 'An error occurred';
};

const supplierCreditService = {
  createTransaction: async (transactionData) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.post(`${SUPPLIER_CREDIT_API_URL}/transactions`, transactionData, {
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getSupplierTransactions: async (supplierId) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.get(`${SUPPLIER_CREDIT_API_URL}/transactions/${supplierId}`, {
        headers
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getSupplierCreditSummary: async (supplierId) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.get(`${SUPPLIER_CREDIT_API_URL}/summary/${supplierId}`, {
        headers
      });
      const data = response.data;
      return {
        totalCreditPurchases: data.totalCreditPurchases || 0,
        totalPayments: data.totalPayments || 0,
        totalReturns: data.totalReturns || 0,
        openingBalance: data.openingBalance || 0,
        balanceDue: data.balanceDue || 0,
        currentBalance: data.currentBalance || 0
      };
    } catch (error) {
      throw handleApiError(error);
    }
  },

  processPayment: async (supplierId, paymentData) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.post(`${SUPPLIER_CREDIT_API_URL}/${supplierId}/payment`, paymentData, {
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  processReturn: async (supplierId, returnData) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.post(`${SUPPLIER_CREDIT_API_URL}/${supplierId}/return`, returnData, {
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  migrateExistingCreditPurchases: async (supplierId) => {
    try {
      const headers = getAuthHeader();
      const response = await axios.post(`${SUPPLIER_CREDIT_API_URL}/migrate/${supplierId}`, {}, {
        headers
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getAllSuppliersWithCreditHistory: async () => {
    try {
      const headers = getAuthHeader();
      const response = await axios.get(`${SUPPLIER_CREDIT_API_URL}/all-suppliers-with-history`, {
        headers
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  fixAllSupplierCreditBalances: async () => {
    try {
      const headers = getAuthHeader();
      const response = await axios.post(`${SUPPLIER_CREDIT_API_URL}/fix-all-balances`, {}, {
        headers
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }
};

export default supplierCreditService;

